









import { Component, Mixins, Prop } from "vue-property-decorator";
import { ModelEditableMixin } from "../../../system/mixins";
import {
  ReferenceFileAccessibleMixin,
  CommonComponentsAccessibleMixin,
} from "../mixins";

@Component
export default class ReferenceFileMenu extends Mixins(
  ModelEditableMixin,
  ReferenceFileAccessibleMixin,
  CommonComponentsAccessibleMixin,
) {
  @Prop({default: "本書類作成上の留意点（説明資料）"})
  buttonName: string;

  open(): void {
    this.commonComponents.adapters.fileViewer.openReferenceFile();
  }
}
